// HERE WE STORE THE QUESTIONS IN THE STORE

import {createSlice} from "@reduxjs/toolkit";

const initialState={
    questions:null
}

const questionsSlice=createSlice({
    name:"questions",
    initialState,
    reducers:{
        storeQuestions:(state,action)=>{
            state.questions=action.payload;
            return state;
        },
        resetQuestions:(state,action)=>{
            state.questions=null;
            return state;
        }
    }
})

export const {storeQuestions,resetQuestions}=questionsSlice.actions;
export default questionsSlice;